import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import { getEnterprise } from './api/request/park'
import tools from '@/utils/tools'
import createSessionStoragePlugin from './plugin/vuex-session-storage'

export default new Vuex.Store({
  state: {
    token: "",
    islogin: true,
    requestCancels: [], // 当前路由的所有Axios请求取消函数
    dimensionList: {},
    userInfo: {}, // 登陆后企业信息
    userInfoMsg: '', // 未登录或登录过期提示
  },
  getters: {

  },
  mutations: {
    loginSuccess (state, payload) {
      state.islogin = payload;
    },
    setDimensionList (state, payload) {
      payload.forEach((item) => {
        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            state.dimensionList[key] = item[key];
          }
        }
      })
    },
    set_userInfo: (state, info) => {
      state.userInfo = info
    },
    set_userInfoMsg: (state, msg) => {
      state.userInfoMsg = msg
    }
  },
  actions: {
    async GetUserInfo ({ commit }) {
      // 第三方接口查询企业信息
      let res = await getEnterprise({
        Token: tools.getCookie('Token')
      })
      let { code, data, msg } = res.data

      if (code === 200) {
        commit('set_userInfo', data)
        commit('set_userInfoMsg', '')
      } else {
        commit('set_userInfo', null)
        commit('set_userInfoMsg', msg)
      }
    }
  },
  modules: {},
  plugins: [createSessionStoragePlugin()]
});
